module.exports = __webpack_public_path__ + "img/9b95c43.png";